import * as Sentry from '@sentry/react';
import ReactDOM from 'react-dom/client';

import App from './App.jsx';
import './index.css';

Sentry.init({
  dsn: import.meta.env.DEV ? '' : import.meta.env.VITE_SENTRY_DSN,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
    Sentry.captureConsoleIntegration({
      levels: ['error'],
    }),
  ],
  // Performance Monitoring
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ['localhost', /^https:\/\/api\.lanetalk\.com\/v1/],
  // Session Replay
  replaysSessionSampleRate: 0.1, // Sample at 10% in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

ReactDOM.createRoot(document.getElementById('root')).render(<App />);
